import { render, staticRenderFns } from "./AssetSale.vue?vue&type=template&id=8c5b6e48&"
import script from "./AssetSale.vue?vue&type=script&lang=js&"
export * from "./AssetSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports